<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-08-03 15:21:19
 * @LastEditTime: 2021-10-09 20:52:17
 * @LastEditors: chenguobiao
-->
<template>
  <div class="replay-detail">
    <div class="replay-detail__correct-answer">
      正确答案：{{correctAnswer.join(',')}}
    </div>
    <div class="replay-detail__your-answer">
      你的答案：{{yourAnswer.join(',')}}
    </div>
    <div class="replay-detail__score">
      得分：{{score}}分
    </div>
  </div>
</template>

<script>
import Chess from 'chess.js'
const game = new Chess()
export default {
  props: ['question'],
  data() {
    return {
      correctAnswer: [],
      yourAnswer: [],
      score: ''
    }
  },
  watch: {
    question: {
      immediate: true,
      handler(question) {
        const questionType = question.typeCode
        this.score = question.userScore
        if (questionType === 'national_iconic') {
          const description = JSON.parse(question.description)
          this.correctAnswer = description.map(ele => {
            const personMoveArray = ele.personMove.map(personMove => {
              return personMove.value
            })
            return personMoveArray.join('或')
          })
          game.load_pgn(question.userAnswer)
          const history = game.history({ verbose: true })
          const filterHistory = history.filter(ele => {
            return ele.color === history[0].color
          })
          // console.log('his', history)
          this.yourAnswer = filterHistory.map(ele => {
            return ele.san
          })
        } else {
          const filterAnswerList = question.answerList.filter(answer => {
            return answer.correct
          })
          this.correctAnswer = filterAnswerList.map(filterAnswer => {
            return filterAnswer.number
          })
          this.yourAnswer = [question.userAnswer]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .replay-detail {
    &__correct-answer,
    &__your-answer,
    &__score {
      font-size: val(20);
      font-weight: 500;
      line-height: val(28);
      color: #3E1500;
    }
    &__your-answer,
    &__score {
      color: #FF6926;
      margin-top: val(8);
    }
  }
</style>
